import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import { showShareDialog } from '../../state/app'
import DialogContainer from '../Dialogs/DialogContainer';
import './share.scss';
import { strings, slugs } from '../../utils/localization';

class ShareDialog extends PureComponent {
    getUrl = () => {
        return typeof window !== 'undefined' ? window.location.href : 'https://fagelaventyret.netlify.com'
    }

    render() {
        const facebookUrl = `https://www.facebook.com/sharer/sharer.php?u=${this.getUrl()}`;
        const twitterUrl = `https://twitter.com/home?status=${this.getUrl()}`;
        const mail = `${slugs.shareMailTo}${this.getUrl()}`;

        return (
            <DialogContainer
                id="share-dialog"
                visible={this.props.showShareDialog}
                title={strings.share}
                onHide={() => this.props.dispatch(showShareDialog(false))}
            >
                <div className={"sharecontainer"} onClick={() => this.props.dispatch(showShareDialog(false))}>
                    <a href={facebookUrl} target="_blank">
                        <span className="facebook"></span>
                    </a>
                    <a href={twitterUrl} target="_blank">
                        <span className="twitter"></span>
                    </a>
                    <a href={mail} target="_blank">
                        <span className="mail"></span>
                    </a>
                </div>
            </DialogContainer>
        )
    }
}

export default connect(state =>
    ({
        showShareDialog: state.app.showShareDialog
    }), null)(ShareDialog)